import React, { useState } from 'react';
import logo from '../../../../../assets/security-details-invite-investors.svg';
import styles from './invite-investors.module.scss';
import ModalCustom from "../../../../../components/modal/modal";
import {Tab, Tabs} from "react-bootstrap";
import InviteInvestorModalContent from "../modal-content-invite-investor/modal-content-invite-investor";
import BatchInviteInvestorModalContent
  from "../modal-content-batch-invite-investor/modal-content-batch-invite-investor";

const InviteInvestors = () => {
  const [show, setShow] = useState(false);
  const onClose = () => setShow(false);

  const action = 'Invite Applicants';
  return (
    <>
      <div onClick={() => setShow(true)} className={styles['logo']}>
        <img alt={action} src={logo} />
        <label>{action}</label>
      </div>
      <ModalCustom
        show={show}
        title={action}
        onClose={onClose}
        component={renderModalContent()}
        style={styles['invite-modal']} />
    </>
  );
}

const renderModalContent = () => {
  return (
    <div className={styles['invite-section']}>
      <Tabs className={styles['invite-section-tabs']} defaultActiveKey='add-investor'>
        <Tab tabClassName={`${styles['tab']}`} eventKey="add-investor" title="Single Invite">
          <InviteInvestorModalContent />
        </Tab>
        <Tab tabClassName={styles['tab']} eventKey="bulk-add-investor" title="Bulk Invite">
          <BatchInviteInvestorModalContent />
        </Tab>
      </Tabs>
    </div>
  )
}

export default InviteInvestors;

